import React from 'react'
import { useFormState } from 'react-final-form'
import { useHistory } from 'react-router-dom'
import { Button } from 'semantic-ui-react'

export const CreateLocalizationActions = () => {
  const { submitting, pristine } = useFormState()
  const history = useHistory()

  const handleCancel = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault()
    history.goBack()
  }
  return (
    <>
      <Button type="button" onClick={handleCancel}>
        Cancel
      </Button>

      <Button type="submit" primary disabled={submitting || pristine}>
        Create
      </Button>
    </>
  )
}
